import { Link } from "react-router-dom";
import { Music, ArrowLeft } from "lucide-react";

const LegalLayout = ({ title, lastUpdated, children }) => (
  <div className="min-h-screen bg-background">
    {/* Header */}
    <header className="border-b border-white/5 sticky top-0 bg-background/80 backdrop-blur-md z-10">
      <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="legal-home-link">
          <div className="w-9 h-9 rounded-lg bg-primary/15 flex items-center justify-center">
            <Music className="w-5 h-5 text-primary" />
          </div>
          <div>
            <p className="font-heading text-base leading-none">Vivo</p>
            <p className="text-[10px] text-muted-foreground uppercase tracking-widest">Musician Management</p>
          </div>
        </Link>
        <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1" data-testid="legal-back-login">
          <ArrowLeft className="w-4 h-4" /> Back to login
        </Link>
      </div>
    </header>
    {/* Body */}
    <div className="max-w-4xl mx-auto px-6 py-10 space-y-6 animate-fade-in">
      <div>
        <h1 className="font-heading text-4xl sm:text-5xl tracking-tight">{title}</h1>
        {lastUpdated && <p className="text-sm text-muted-foreground mt-2">Last updated: {lastUpdated}</p>}
      </div>
      <div className="prose-vivo text-[15px] leading-relaxed space-y-5">
        {children}
      </div>
    </div>
    {/* Footer */}
    <footer className="border-t border-white/5 mt-16">
      <div className="max-w-4xl mx-auto px-6 py-8 text-xs text-muted-foreground flex flex-wrap gap-4 justify-between">
        <span>© {new Date().getFullYear()} Vivo Musician Management · James Fiddeman</span>
        <div className="flex gap-4">
          <Link to="/privacy" className="hover:text-foreground">Privacy</Link>
          <Link to="/cookies" className="hover:text-foreground">Cookies</Link>
          <Link to="/terms" className="hover:text-foreground">Terms</Link>
          <Link to="/support" className="hover:text-foreground" data-testid="legal-footer-support">Support</Link>
        </div>
      </div>
    </footer>
  </div>
);

export default LegalLayout;
